import { makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
// import { useHistory } from 'react-router';
// import axios from 'axios';
// import Grid from '@material-ui/core/Grid';
// import Button from '@material-ui/core/Button';
// import CircularProgress from '@material-ui/core/CircularProgress';
// import { RowingOutlined } from '@material-ui/icons';
import Layout from '../../invoices/common/Layout';
import PaymentTable from '../PaymentTable/PaymentTable';
// import { getPaymentsDetails } from '../store/actions/index';
// import EmailDialog from '../../../components/table/EmailDialog';
import LoaderPopUp from '../../../components/loaderpopup/loader'

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(6),
    },
}));

const structure = [
    {
        invoiceId: {
            invoiceNumber: '123/2020-21',
            invoiceDate: '2020-10-21 15:30:53',
            total: '1900',
        },
        referenceNumber: '09090',
        paymentDate: '2020-07-03T18:30:00Z',
        status: 'Paid'
    },
    {
        invoiceId: {
            invoiceNumber: '124/2020-21',
            invoiceDate: '2020-10-21 15:30:53',
            total: '2000',
        },
        referenceNumber: '09090',
        paymentDate: '2020-07-03T18:30:00Z',
        status: 'Failed'
    },
    {
        invoiceId: {
            invoiceNumber: '125/2020-21',
            invoiceDate: '2020-10-21 15:30:53',
            total: '5600',
        },
        referenceNumber: '09090',
        paymentDate: '2020-07-03T18:30:00Z',
        status: 'Paid'

    },
];

function ItecPayments() {
    // const history = useHistory();
    const [searchQuery, setSearchQuery] = useState('');
    const [rows, setTotalReactPackages] = useState([]);
    // const [handleGeneratedReceipt, setHandleGeneratedReceipt] = useState([]);
    const [showBtnLoader, setShowBtnLoader] = useState(false);

    const headcells = [
        {
            id: 'invoiceId',
            label: 'Invoice Number',
            isConcat: 'true',
            concatElem: ['invoiceNumber'],
        },
        {
            id: 'invoiceId',
            label: 'Invoice Date',
            isConcat: 'true',
            concatElem: ['invoiceDate'],
            date: 'true',
        },
        {
            id: 'invoiceId',
            label: 'Invoice amount',
            isConcat: 'true',
            concatElem: ['total'],
        },
        {
            id: 'razorpayPaymentId',
            label: 'Reference Number',
        },
        {
            id: 'paymentDate',
            label: 'Amount Received on',
            date: 'true',
        },
        {
            id: 'status',
            label: 'Status',
        },
    ];

    const getCandidates = () => {
        // dispatch(getPaymentsDetails());

        const data = structure.map((row) => {
            return row;
        });
        setTotalReactPackages(data);
    };
    useEffect(() => {
        getCandidates();
    }, []);

    // const allImcsOptions = (vv) => {
    //     const OptionList = vv.map((data) => <option value={data.dbName}>{data.dbName}</option>);
    //     return OptionList;
    // };

    // const handleGenerateReceipt = (data) => {
    //     ////console.log('data', data);
    //     ////console.log('item', data.paymentId);
    //     setShowBtnLoader(true);

    //     if (data.paymentId) {
    //         axios
    //             .post(`http://172.16.238.236:5020/api/auth/generate-receipt/Advith/${data.paymentId}`)
    //             .then((response) => {
    //                 setHandleGeneratedReceipt(response.data.content)
    //                 setShowBtnLoader(false)
    //             })
    //             .catch((error) => {
    //                 const errResult = error.response;
    //                 ////console.log('errResult', errResult);
    //                 if (errResult.data) {
    //                     ////console.log('errResult.error', errResult.data.message);
    //                 }
    //             });
    //    }
    // });

    // search Query
    const handleSearchQuery = (searchData) => {
        //console.log(searchData);
        setSearchQuery(searchData);
    };

    // const setImc = (e) => {
    //     setselectedImc(e.target.value);
    //     axios
    //         .get(`http://172.16.238.236:5020/api/auth/payment-history/${e.target.value}?page=0&size=100&sort=paymentId,desc`)
    //         .then((response) => {
    //             setTotalReactPackages(response.data.content);
    //             //console.log(response.data.content);
    //         })
    //         .catch((error) => {
    //             //console.log(error.response.data);
    //             // if (error.response.data) {
    //             //     setTotalReactPackages([]);
    //             // }
    //         });
    // };

    // Filtered Row based on search
    // const filteredRow = searchQuery
    //     ? rows.filter((rowData) => {
    //         const query = searchQuery.toLowerCase().trim();
    //         return headcells
    //             .map((col) => col.id)
    //             .some((key) => {
    //                 return rowData[key].toString().toLowerCase().includes(query);
    //             });
    //     })
    //     : rows;

    // Search through nested objects
    const filteredRow = searchQuery
        ? rows.filter((searchRow) => {
            const query = searchQuery.toLowerCase().trim();
            //   ////console.log(Object.keys(row) ,"Keys of ROW**** object.keys()");
            return headcells
                .map((col) => col)
                .some((key) => {
                    //   ////console.log(key, 'from inside some');

                    if (key.isConcat && searchRow[key.id]) {
                        //   ////console.log("Search Row",searchRow);
                        const subdata = searchRow[key.id];
                        //   ////console.log(subdata,"subData");
                        const mergedData = key.concatElem.map((concatdata) => {
                            //   ////console.log(concatdata,"concatData");
                            return concatdata.split('.').reduce((acc, item) => {
                                //console.log(acc ,item,"Acc item from reduce")
                                if (Object.prototype.hasOwnProperty.call(acc, item)) {
                                    if (typeof acc[item] !== "object") {

                                        return acc[item].toString().toLowerCase().includes(query);
                                    }
                                    return acc[item];
                                }
                                return false;
                            }, subdata);
                        });
                        //console.log(mergedData,"mergeData");

                        return mergedData[0];
                    }
                    return searchRow[key.id].toString().toLowerCase().includes(query);
                });
        })
        : rows;

    const classes = useStyles();
    return (
        <>
            {
                (showBtnLoader && (
                    <LoaderPopUp showLoader={showBtnLoader} />
                    // <div style={{ position: 'relative', top: 300, left: 700 }}>
                    //     <span style={{ position: 'absolute', top: 20 }}>Loading......</span>
                    //     <CircularProgress style={{ color: '#F8951B' }} size={20} />
                    // </div>
                )) || (
                    <div className={classes.root}>
                        <Layout title="ITeC Payment History" searchQuery={searchQuery} onChange={handleSearchQuery} className={classes} />
                        {filteredRow.length === 0 && <span style={{ fontSize: '14px', fontWeight: '500' }}>No records found to display!</span>}
                        <PaymentTable headcells={headcells} rows={filteredRow} pageName="itec" />
                    </div>
                )}
        </>
    );
}

export default ItecPayments;
